@if (priority()) {
  <img
    #image
    [attr.alt]="alt()"
    [attr.aria-hidden]="ariaHidden()"
    [attr.class]="className()"
    [attr.loading]="loading()"
    [ngSrc]="src()"
    [height]="height()"
    [width]="width()"
    priority />
} @else {
  <img
    #image
    animate.enter="image-fade-in"
    [attr.alt]="alt()"
    [attr.aria-hidden]="ariaHidden()"
    [attr.class]="className()"
    [attr.loading]="loading()"
    [ngSrc]="src()"
    [height]="height()"
    [width]="width()" />
}
